import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "分类", path: "/category" },
  { label: "专题", path: "/topic" },
  { label: "搜索", path: "/search" },
  { label: "关于", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[68px]">
          <Link to="/" className="flex items-center gap-2 cursor-pointer shrink-0">
            <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xl">
              <i className="ri-flower-fill"></i>
            </span>
            <span className="font-brand text-xl md:text-2xl text-foreground-950 whitespace-nowrap">
              樱花动漫在线
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 lg:gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "bg-primary-100 text-primary-800"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/search"
              className="hidden md:flex items-center gap-2 h-9 pl-3 pr-4 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-500 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line text-base"></i>
              <span>搜索动漫</span>
            </Link>
            <button
              type="button"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="打开菜单"
              className="md:hidden w-9 h-9 rounded-md border border-background-200 text-foreground-800 flex items-center justify-center cursor-pointer"
            >
              <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3 animate-fadeIn">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-100 text-primary-800"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}